import React from 'react'
import ReactPlayer from 'react-player'
import { withStyles } from '@material-ui/core/styles'

import { GRADIENTS } from '../../../utils/constants'
import styles from './styles'

const Header = withStyles(styles)(props => {
  const { image, video, gradient } = props
  const { urls, poster } = video

  let header = ''

  if (urls !== undefined && poster !== undefined) {
    header = (
      <ReactPlayer
        url={urls[0].src}
        width={'100%'}
        height={'100%'}
        loop
        autoPlay
        playing
        muted
        style={{ minHeight: 500, maxHeight: '99vh' }}
      />
    )
  } else if (image.src && image.sizes) {
    header = <img src={image.src} style={{ width: '100%', height: '100vh' }} />
  } else if (gradient) {
    header = (
      <img
        style={{
          backgroundImage: GRADIENTS[gradient],
          height: '100vh',
          width: '100%',
        }}
      />
    )
  } else {
    header = (
      <img
        style={{
          backgroundImage:
            'linear-gradient(to right top, #b8557b, #ba398b, #ae1da6, #8c17c9, #072ff0)',
          height: '100vh',
          width: '100%',
        }}
      />
    )
  }

  return header
})

export default withStyles(styles)(Header)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/header.js